import { Component } from "@angular/core";
import { BUILD_INFO } from "../../../environments/build-info";

@Component({
  selector: "app-build-version-badge",
  template: `
    <aside
      class="build-version-badge"
      [attr.title]="tooltip"
      aria-label="เวอร์ชันเว็บปัจจุบัน"
    >
      <span class="build-version-badge__sha">{{ label }}</span>
    </aside>
  `,
  styles: `
    :host {
      position: fixed;
      left: 3.5rem;
      bottom: max(0.5rem, env(safe-area-inset-bottom, 0px));
      z-index: 2147483000;
      pointer-events: none;
    }

    .build-version-badge {
      pointer-events: auto;
      max-width: min(70vw, 16rem);
      padding: 0.2rem 0.45rem;
      border-radius: 999px;
      border: 1px solid rgba(15, 23, 42, 0.12);
      background: rgba(15, 23, 42, 0.55);
      color: rgba(248, 250, 252, 0.92);
      font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
      font-size: 0.65rem;
      line-height: 1.2;
      letter-spacing: 0.02em;
      user-select: text;
      backdrop-filter: blur(4px);
    }

    .build-version-badge__sha {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  `,
})
export class BuildVersionBadgeComponent {
  readonly label = `v${BUILD_INFO.version} : ${BUILD_INFO.commitSha}`;
  readonly tooltip = [
    `version v${BUILD_INFO.version}`,
    `commit ${BUILD_INFO.commitSha}`,
    BUILD_INFO.branch ? `branch ${BUILD_INFO.branch}` : "",
    BUILD_INFO.builtAt ? `built ${BUILD_INFO.builtAt}` : "",
  ]
    .filter(Boolean)
    .join("\n");
}
